// Countries backup array
export const COUNTRIES_BACKUP = [{
    "value": "US",
    "states": {
      "WY": "Wyoming",
      "WI": "Wisconsin",
      "WV": "West Virginia",
      "WA": "Washington",
      "VA": "Virginia",
      "VT": "Vermont",
      "UT": "Utah",
      "TX": "Texas",
      "TN": "Tennessee",
      "SD": "South Dakota",
      "SC": "South Carolina",
      "RI": "Rhode Island",
      "PA": "Pennsylvania",
      "OR": "Oregon",
      "OK": "Oklahoma",
      "OH": "Ohio",
      "ND": "North Dakota",
      "NC": "North Carolina",
      "NY": "New York",
      "NM": "New Mexico",
      "NJ": "New Jersey",
      "NH": "New Hampshire",
      "NV": "Nevada",
      "NE": "Nebraska",
      "MT": "Montana",
      "MO": "Missouri",
      "MS": "Mississippi",
      "MN": "Minnesota",
      "MI": "Michigan",
      "MA": "Massachusetts",
      "MD": "Maryland",
      "ME": "Maine",
      "LA": "Louisiana",
      "KY": "Kentucky",
      "KS": "Kansas",
      "IA": "Iowa",
      "IN": "Indiana",
      "IL": "Illinois",
      "ID": "Idaho",
      "HI": "Hawaii",
      "GA": "Georgia",
      "FL": "Florida",
      "DC": "District of Columbia",
      "DE": "Delaware",
      "CT": "Connecticut",
      "CO": "Colorado",
      "CA": "California",
      "AR": "Arkansas",
      "AZ": "Arizona",
      "AK": "Alaska",
      "AL": "Alabama"
    },
    "label": "United States"
  }, {
    "value": "CA",
    "states": {
      "YT": "Yukon Territories",
      "SK": "Saskatchewan",
      "QC": "Quebec",
      "PE": "Prince Edward Island",
      "ON": "Ontario",
      "NU": "Nunavut",
      "NS": "Nova Scotia",
      "NT": "Northwest Territories",
      "NL": "Newfoundland and Labrador",
      "NB": "New Brunswick",
      "MB": "Manitoba",
      "BC": "British Columbia",
      "AB": "Alberta"
    },
    "label": "Canada"
  }];